export const TEXT = {
  INFO: 'Something went wrong',
  DESCRIPTION: 'Oops! Something seems broken here. Come back later & try again.',
  BACK_LINK_LABEL: 'GO BACK',
};
